/** 同一运行上下文共用一次令牌续签；每个请求至多重试一次，不重建 iframe。 */
export function createComponentRuntimeRequest(options: {
  getToken: () => string;
  getScope: () => number;
  renewToken: () => Promise<void>;
}) {
  let renewal: { scope: number; promise: Promise<void> } | undefined;
  return async <T>(request: (token: string) => Promise<T>, scope = options.getScope()): Promise<T> => {
    const token = options.getToken();
    if (!token) throw new Error('组件运行上下文尚未就绪');
    const assertCurrent = () => {
      if (options.getScope() !== scope || !options.getToken())
        throw new Error('组件运行上下文已变化，请重新操作');
    };
    assertCurrent();
    try {
      const result = await request(token);
      assertCurrent();
      return result;
    } catch (error) {
      if (
        typeof error !== 'object' || error === null ||
        !('status' in error) || error.status !== 401 ||
        ('code' in error && error.code === 'RUNTIME_CONTEXT_INVALID')
      ) throw error;
      assertCurrent();
      // 较晚返回的旧令牌 401 直接使用已更新令牌，不再重复续签。
      if (options.getToken() === token) {
        if (!renewal || renewal.scope !== scope) renewal = { scope, promise: options.renewToken() };
        const pending = renewal;
        try {
          await pending.promise;
        } finally {
          if (renewal === pending) renewal = undefined;
        }
      }
      assertCurrent();
      const result = await request(options.getToken());
      assertCurrent();
      return result;
    }
  };
}
